const POSTCODE_PATTERNS = [
  /^[a-zA-Z]{1,2}\d[\dA-Za-z]? ?\d[A-Za-z]{2} *$/,
];

/**
 * Validates a UK postcode against all valid patterns
 * @param {string} postcode - The postcode to validate
 * @returns {boolean} - True if the postcode is valid, false otherwise
 */
export const validatePostcode = (postcode) => {
  // Return false for null, undefined, or empty strings
  if (!postcode || typeof postcode !== "string") {
    return false;
  }

  // Trim whitespace from the input
  const trimmedPostcode = postcode.trim();

  // Return false for empty string after trimming
  if (trimmedPostcode === "") {
    return false;
  }

  // Test against all patterns
  return POSTCODE_PATTERNS.some((pattern) => pattern.test(trimmedPostcode));
};

/**
 * Formats a postcode to standard format (uppercase with space)
 * @param {string} postcode - The postcode to format
 * @returns {string} - The formatted postcode or original if invalid
 */
export const formatPostcode = (postcode) => {
  if (!validatePostcode(postcode)) {
    return postcode;
  }

  // Remove all spaces and convert to uppercase
  const cleaned = postcode.replaceAll(/\s/g, "").toUpperCase();

  // Insert space before the last 3 characters
  if (cleaned.length >= 3) {
    return cleaned.slice(0, -3) + " " + cleaned.slice(-3);
  }

  return cleaned;
};

export const getPostcodeValidationError = (postcode) => {
  const trimmedPostcode = postcode.trim();
  if (trimmedPostcode === "") {
    return null;
  }

  if (!validatePostcode(trimmedPostcode)) {
    return "Please enter your business site postcode";
  }

  return null;
};
